<script setup lang="ts">
interface Props {
  state?: Record<string, any>
  schema?: any
  validate?: (state: Record<string, any>) => Promise<any[]> | any[]
  validateOn?: string[]
}

const props = withDefaults(defineProps<Props>(), {
  state: () => ({}),
  validateOn: () => ['submit']
})

const emit = defineEmits<{
  submit: [data: { data: Record<string, any> }]
  error: [errors: any[]]
}>()

const errors = ref<any[]>([])

const handleSubmit = async () => {
  errors.value = []

  if (props.validate) {
    const validationErrors = await props.validate(props.state)
    if (validationErrors && validationErrors.length > 0) {
      errors.value = validationErrors
      emit('error', validationErrors)
      return
    }
  }

  emit('submit', { data: props.state })
}

provide('form-errors', errors)
provide('form-state', props.state)
</script>

<template>
  <form @submit.prevent="handleSubmit">
    <slot :errors="errors" />
  </form>
</template>
